import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Stack} from "@mui/material"
import {deleteNoteAttachment, deleteTipTapDocumentAndNoteAttachment} from "../../../../../reducers/noteAttachmentsSlice"
import {useDispatch} from "react-redux"
import {useWorkspaceContext} from "../../../../../pages/Dashboard"

export default function DeleteAttachmentModal({openDeleteModal, setOpenDeleteModal, attachment}) {
	const dispatch = useDispatch()
	const { workspaceId } = useWorkspaceContext()
	return (
		<Dialog
			open={openDeleteModal}
			onClose={() => setOpenDeleteModal(false)}
			sx={{ textAlign: "center" }}
		>
			<DialogTitle>Are you sure you want to delete this note attachment?</DialogTitle>
			<DialogContent>

				<DialogContentText variant="body1" sx={{color: "black"}} paragraph gutterBottom>
					Deleting this attachment cannot be undone.
				</DialogContentText>

				<DialogActions
					sx={{
						flexDirection: "row",
						display: "flex",
						justifyContent: "center"
					}}
					disableSpacing>
					<Stack width="75%" spacing={4} direction="row">

						<Button
							fullWidth
							variant={"outlined"}
							color="primary"
							onClick={() => setOpenDeleteModal(false)}
						>
							Cancel
						</Button>

						<Button
							fullWidth
							variant="contained"
							color="error"
							onClick={() => {
								attachment.attachmentType === "doc" && dispatch(deleteTipTapDocumentAndNoteAttachment({attachment, workspaceId}))
								attachment.attachmentType === "url" && dispatch(deleteNoteAttachment({attachment, workspaceId}))
								setOpenDeleteModal(false)
							}}>
							Delete
						</Button>

					</Stack>
				</DialogActions>
			</DialogContent>
		</Dialog>
	)
}